export default __webpack_public_path__ + "static/media/cmmnt.45431b83.svg";